<template>
      <div class="reply contains">
        <div  class="content-tit">
          <div class="flex-box">
            <h2>快捷问题</h2>
            <el-button type="primary" class="add" @click="dialogVisible1 ">添加快捷问题</el-button>
            <el-input placeholder="搜索快捷问题" v-model="value1" style="    margin-right: 40px;">
              <el-button slot="append" icon="el-icon-search" @click="Select"></el-button>
            </el-input>
            <div class="clear"></div>

            <el-dialog :title="TypeTrueModel" :visible.sync="dialogVisible" width="30%">
              <div class="dialog">
                <div class="section">
                  <span class="label">渠道名称</span>
                  <div class="input_box">
                     <el-select  placeholder="全部留言"  v-model="Add.MiniChannelId" >
                          <el-option
                            v-for="item in option2"
                            :key="item.id"
                            :label="item.name" 
                            :value="item.id">
                          </el-option>
                        </el-select>
                    </el-input>
                  </div>
                  <div class="clear"></div>
                </div>
               <div class="section">
               <span class="label">快捷问题</span>
                  <div class="input_box">
                    <el-input placeholder="请输入内容" class="input" v-model="Add.ProblemContent">
                    </el-input>
                  </div>
                  <div class="clear"></div>
                </div>

                <div class="section">
               <span class="label">状态</span>
                  <div class="input_box">
                  <el-radio v-model="Add.state" label="1">启用</el-radio>
                  <el-radio v-model="Add.state" label="0">禁用</el-radio>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                            <el-button @click="Close">取 消</el-button>
                            <el-button type="primary" @click="Add1"  v-if="TypeTrue!=true" >确 定</el-button>
                             <el-button type="primary"  v-if="TypeTrue!=false" @click="Update" >修改</el-button>
                         </span>
            </el-dialog>
          </div>
        </div>
        <div class="content-main">
          <div class="flex-box">
            <div class="table_box">
              <el-table  :data="tableData" style="width: 100%;" border>
                 <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="Name" label="渠道名称" width="200"></el-table-column>
                <el-table-column prop="ProblemContent" label="快捷问题"></el-table-column>
                <el-table-column prop="state" label="状态"  width="200" ></el-table-column>
                <!-- <el-table-column prop="operate" label="操作" width="200">
                  <i class="el-icon-edit" @click="UpdateShow()" style="cursor: pointer;"></i>
                  <i class="el-icon-delete" style="cursor: pointer;"></i>
                </el-table-column> -->
                  <el-table-column
                          fixed="right"
                          label="操作"
                          width="200">
                          <template slot-scope="scope">
                                <i class="el-icon-edit" @click="UpdateShow(scope.row.Id)" style="cursor: pointer;"></i>
                                 <i class="el-icon-delete" style="cursor: pointer;" @click="Delete(scope.row.Id)"></i>
                            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                            <el-button type="text" size="small">编辑</el-button> -->
                          </template>
                        </el-table-column>

              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
               @current-change="List"
                background
                layout="total, prev, pager, next"
                :total="SumUser">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
    export default {
        name:'channel',
        props: [],
        data() {
            return{

              MiniChannelEnum:{
                  Id:0,
                  Name:"",
                  Value:"",
                  remark:"",
                  state:'1',
                    url:"",
                   AppId:"",
                   SelfJump:'1',
                   create_time:"2019-12-27"
              },
              TypeTrue:false,
              TypeTrueModel:"添加快捷问题",
              value1:"",
              value2:"",
              value3:"",
              tableData:[
                ],
              dialogVisible:false,
              options: [{
                value: '选项1',
                label: '黄金糕'
              }, {
                value: '选项2',
                label: '双皮奶'
              }],
               SumUser:0,
               option2:[],
               Add:{ 
                   Id:0,
                   MiniChannelId:0,
                   ProblemContent:"",
                   Clicks:0,
                   CreateTime:"2019-1-1",
                   state:"0"
               }  
               
            }
        },
        watch: {},
        mounted: function () {
            this.List(1);
        },
        created:function(){
            this.Total();
            this.SelectList();
        },
        methods: {
               SelectList(){
              let $this=this;
              $this.option2=[];
              this.axios.get("MiniChannelEnum/SelectList",{
                headers:{
                  'Content-Type':'application/json'
                }
              }).then(function(data){
                data.data.forEach(element => {
                   $this.option2.push(element);
                   $this.Add.MiniChannelId= $this.option2[0].id;
                });
              })
          },
       Total(KeyWord){
             //初始化  客服总人数
          let $this=this;
          this.axios.get('ChannelProblem/total',{params:{
            ProblemContent:$this.value1
          }},{
            headers:{
              'Content-Type':'application/json'
            }
          }).then(function(data){
            $this.SumUser=data.data;
          })
          },
            //返回用户列表
          List(PageSize,PageNum,KeyWord){
               PageNum=10;
              let $this = this;
            this.axios.get('ChannelProblem/List',{params:{
              pages:PageSize,
              pageNum:PageNum,
              ProblemContent:$this.value1
            }},{
              headers:{
                'Content-Type':'application/json'
              }
            }).then(function(data){

                $this.tableData=[];
              data.data.forEach(element => {
                $this.tableData.push({
                  Id:element.id,
                   Name:element.name,
                ProblemContent: element.problemContent,
                state:element.state,
                  operate:'未处理'
                });
              
              });
            })
          },
           Select(){
               let $this = this;
                $this.List(1,10,$this.value1)
                 $this.Total($this.value1);
               
          },
          //添加
          Add1(){
           let $this=this;
                var booleam=true;
                if($this.Add.ProblemContent==""){
                  $this.$message.error("请输入快捷问题")
                      booleam=false;
                }
         if(booleam){

        //   if($this.MiniChannelEnum.SelfJump=="0"){
        //     $this.MiniChannelEnum.SelfJump=false;
        //   }
        //   else{
        //      $this.MiniChannelEnum.SelfJump=true;
        //   }

            this.axios.post("ChannelProblem/Add",$this.Add,{
              headers:{
                'Content-Type':'application/json'
              }
            }).then(function(data){
              if(data.data.message=="成功"){
                   $this.$message(data.data.message)
                   $this.Add.Id=0;
                   $this.Add.MiniChannelId=$this.option2[0].id;
                   $this.Add.ProblemContent="";
                   $this.Add.state="1";
                    $this.dialogVisible = false;
                      $this.Total();
                      $this.List(1);
              }
              else{
                $this.$message.error(data.data.message)
              }
            })
            
         } 
          },
          //弹框
          UpdateShow(Id){
              let $this=this;
              $this.TypeTrueModel="修改快捷问题";
              $this.dialogVisible=true;
              $this.TypeTrue=true;

              $this.axios.get("ChannelProblem/Update_Model",{
                params:{Id:Id}
              },{
                headers:{
                  'Content-Type':'application/json'
                }
              }).then(function(data){
                    $this.Add.Id=Id;
                    $this.Add.MiniChannelId=data.data.miniChannelId;
                    $this.Add.ProblemContent=data.data.problemContent;
                     if(data.data.state==1){
                         $this.Add.state="1";
                    }
                    else{
                       $this.Add.state="0";
                    }
              })

          },
          dialogVisible1(){
            let $this=this;

            $this.TypeTrueModel="添加渠道";
            $this.dialogVisible= true;
            $this.TypeTrue=false;

          },
          //取消
          Close(){
                let $this=this;
                   $this.Add.MiniChannelId=$this.option2[0].id;
                   $this.Add.ProblemContent="";
                   $this.Add.state="0";
                 
                     $this.dialogVisible= false;
          },
          //修改
          Update(){
                let $this=this;
                var booleam=true;

                if($this.Add.ProblemContent==""){
                  $this.$message.error("请输入快捷问题");
                      booleam=false;
                }

                if(booleam){

                    this.axios.post("ChannelProblem/Update",$this.Add,{
                      headers:{
                        'Content-Type':'application/json'
                      }
                    }).then(function(data){
                       if(data.data.message=="成功"){
                          $this.$message(data.data.message);
                           $this.dialogVisible = false;
                            $this.Total();
                          $this.List(1);
                       }
                       else{
                         $this.$message.error(data.data.message);
                       }
                    })
                }
          },
          //删除
          Delete(Id){
                let $this=this;
              var mymessage=confirm("是否删除？");
              if(mymessage==true)
              {
                  $this.axios.post("ChannelProblem/Delete?Id="+Id,{
                    headers:{
                      'Content-Type':'application/json'
                    }
                  }).then(function(data1){
                    if(data1.data.message=="成功"){
                        $this.$message(data1.data.message);
                          $this.Total();
                          $this.List(1);
                    }
                    else{
                         $this.$message.error(data1.data.message)
                    }
                  })
                }
              else if(mymessage==false)
              {
               
              }
          },
        //   Close(){
        //     let $this=this;
        //     $this.dialogVisible=false;
        //   }
          

        }
    }
</script>

<style scoped>
  .content-tit{
    line-height:20px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom:5px;
  }
  .content-tit h2{
    font-size:20px;
    line-height:30px;
    font-weight:normal;
    float: left;
  }
  .flex-box{
    width:100%;
  }
  .add{
    float: right;
  }
  .import{
    float: right;
  }
  .export{
    float: right;
    margin-right:10px;
  }
  .delete{
    float: right;
    margin-right:10px;
  }
  .pagination{
    text-align: right;
  }
  .el-pagination{
    text-align: right;
    margin-top:50px;
    display: inline-block;
  }

  .label{
    float: left;
    width:120px;
    text-align: right;
    margin-right:20px;
  }
  .section{
    line-height:50px;
    margin-top:10px;
  }
  .input_box{
    float: left;
    width:60%;
  }
  .input_box .input{
    width:100%;
  }
  .table_box{
    margin-top:50px;
  }
</style>
<style>
 .reply  .el-input-group{
    float: right;
    width: 320px;
  }
 .reply .el-textarea__inner{
   height:100px;
   background-color:#fafafa;
 }
</style>




// WEBPACK FOOTER //
// src/components/manage/setting/ChannelProblem.vue